module.exports = __webpack_public_path__ + "static/mario-1106163ca4382ad1b0eba888db8beafc.png";